import { createSlice } from "@reduxjs/toolkit";

export const formHelperSlice = createSlice({
  name: "formHelper",
  initialState: {  
    isResetForm : false
  },
  reducers: { 
    updateIsResetForm: (state, action) => {
    
      state.isResetForm = action.payload; 
      return state;
    },
   
  },
});
export const { updateIsResetForm } = formHelperSlice.actions;

 

export const formHelperReducer = formHelperSlice.reducer;


